import * as yup from 'yup';

/** Service object with common utils to validate document type codes. Singleton object. */
export class DocumentTypeCodeValidateTools {
  /** Instance for whole application */
  private static instance: DocumentTypeCodeValidateTools;

  /**
   * Get {@link DocumentTypeCodeValidateTools} instance. Create it if not exists.
   *
   * @returns Common utils to validate document type codes
   */
  public static getInstance(): DocumentTypeCodeValidateTools {
    if (!DocumentTypeCodeValidateTools.instance) {
      DocumentTypeCodeValidateTools.instance = new DocumentTypeCodeValidateTools();
    }
    return DocumentTypeCodeValidateTools.instance;
  }

  /** Regular expression to match code patterns */
  public readonly matchRegex: RegExp;

  /** Express router parameter pattern (to insert into routes) */
  public readonly routeRegex: string;

  /** Localied human-readable error message */
  public readonly errorMessage: string;

  /** Single string validation schema for `yup` */
  public readonly yupSchema: yup.StringSchema;

  /** Strings array validation schema for `yup` */
  public readonly yupArraySchema: yup.ArraySchema<string[], yup.AnyObject>;

  private constructor() {
    this.matchRegex = /^[a-z\-_]*[a-z]{1}$/i;
    this.routeRegex = '(^[a-z\\-_]*[a-z]{1}$)';
    this.errorMessage = 'Код может содержать только латинские буквы, знаки "-" или "_". Код должен заканчиваться латиской буквой.';
    this.yupSchema = yup
      .string()
      .matches(this.matchRegex, this.errorMessage);
    this.yupArraySchema = yup.array(this.yupSchema);
  }
}
